import * as Yup from 'yup';
import { CasReactHookFormDialog, CasRHFSelect } from 'src/compass/shared/components';
import { CasRHFRiskManagerSelect } from 'src/compass/application';
import useUpdateMutation from 'src/compass/shared/hooks/reactQuery/useUpdateMutation';
import { onSuccessEnqueueSnackbar } from 'src/compass/shared/util/onSuccessEnqueueSnackbar';
import { getSelectSchema } from 'src/compass/shared/schemas';

// The customer's Service Owner - Entity.RMCOfRecordEmployeeId, labeled Service Owner everywhere a
// customer's (as opposed to an account's) is shown.
const Schema = Yup.object().shape({
  employeeId: getSelectSchema('Service Owner'),
});

export type RiskManagerType = { id: number; name: string };

type Props = {
  entityId: number;
  employeeId?: number | null;
  /*
    The customer's Risk Managers - the only valid choices (the API refuses anyone else). A
    customer with none yet picks from every Risk Manager and Bus Dev employee instead.
  */
  riskManagers: RiskManagerType[];
  onClose: VoidFunction;
  onSaved: VoidFunction;
};

export default function RMCOfRecordDialog({
  entityId,
  employeeId,
  riskManagers,
  onClose,
  onSaved,
}: Props) {
  const { mutate } = useUpdateMutation({
    url: 'Utilities/EntityTouchpoint/UpdateRMCOfRecord',
    onSuccess: (response) => {
      onSuccessEnqueueSnackbar(response);
      onSaved();
    },
  });

  return (
    <CasReactHookFormDialog
      open
      title="Service Owner"
      submitButtonLabel="Update"
      onClose={onClose}
      // A current Service Owner from outside the Risk Managers starts blank, so it has to be
      // replaced.
      defaultValues={{
        employeeId:
          !riskManagers.length || riskManagers.some((rm) => rm.id === employeeId)
            ? employeeId
            : null,
      }}
      schema={Schema}
      onSubmit={(data) => mutate({ entityId, employeeId: data.employeeId })}
    >
      {riskManagers.length ? (
        <CasRHFSelect name="employeeId" label="Service Owner" options={riskManagers} />
      ) : (
        <CasRHFRiskManagerSelect includeBusDev name="employeeId" label="Service Owner" />
      )}
    </CasReactHookFormDialog>
  );
}
